import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
const isV3 = allVue.version && allVue.version[0] === '3'
import KendoDropDownTreeMixin from './KendoDropDownTreeMixin'

export default {
    name: 'kendo-dropdowntree',
    mixins: [ KendoDropDownTreeMixin ],
    setup() {
        const v3 = isV3
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement

        var tagName = (this.$props.checkboxes || this.$props.checkboxesCheckChildren ||
            this.$props.checkboxesName || this.$props.checkboxesTemplate) ? 'select': 'input'
   
        return h(tagName, [
            this.$slots['kendo-hierarchicaldatasource']
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowntree-vue-wrapper/src/KendoDropDownTree/index.js